import { useQuery } from '@tanstack/vue-query';
import apiInterceptor from '@/shared/apiInterceptor';
import { environment } from '@/shared/env';

export const businessRolesQueryOptions = {
  queryKey: ['business-roles'],
  queryFn: async () => {
    const r = await apiInterceptor.get(environment('VUE_APP_API_URL') + 'roles/v1/business_roles/');
    return Array.isArray(r) ? r : (r?.data || []);
  },
  staleTime: Infinity,
};

export function useBusinessRoles() {
  return useQuery(businessRolesQueryOptions);
}
